import React from 'react';
import './user-info.scss';
import avt from '../../assets/images/avt.jpg';
import Add from '../../assets/images/Add.svg';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar } from '@material-ui/core';
import { toggleChangeLogoModal } from '../../reducers/UiReducer';

const UserInfo = () => {
	const { travellerlogin, agentlogin } = useSelector((state) => state.user);
	const dispatch = useDispatch();
	return (
		<div>
			{/* <div className='user-info__img'>
				<img src={avt} alt='' width='50px' height='50px' />
			</div> */}
			<div
				style={{ cursor: 'pointer' }}
				className='user-info__name'
				onClick={() => dispatch(toggleChangeLogoModal(true))}>
				<img
					src={Add}
					alt='AddPatientIcon'
					height='40'
					style={{ borderRadius: 10 }}
					width='40'
					// onClick={() => fileInputRef.current.click()}
				/>
				<span
					style={{ fontSize: 14, marginLeft: 10, textTransform: 'uppercase' }}>
					{travellerlogin
						? travellerlogin &&
						  travellerlogin.result &&
						  travellerlogin.result.result &&
						  travellerlogin.result.result.name
						: agentlogin
						? agentlogin &&
						  agentlogin.result &&
						  agentlogin.result.result &&
						  agentlogin.result.result.name
						: ''}
				</span>
			</div>
		</div>
	);
};

export default UserInfo;
